import React from 'react';
import { SimpleModal } from '../../../../components/SimpleModal';
import { DoctorScheduling } from '../../../../components/Icons';
import { SystemUnavailableProps } from '../../../../components/SystemUnavailable';
import { Button } from '../../../../components';

export type FirstAppointmentModalProps = { handleContinue: () => void } & SystemUnavailableProps;

export const FirstAppointmentModal: React.FC<FirstAppointmentModalProps> = ({ visible, onClose, handleContinue }) => {
  return (
    <SimpleModal
      visible={visible}
      onClose={onClose}
      title="Vamos agendar sua primeira consulta"
      subtitle="Para começar, você precisa escolher uma Clínica Einstein para ser vinculado a uma equipe de cuidado."
      mainIcon={<DoctorScheduling />}
      customFooterContainer={
        <>
          <Button disabled={!visible} type="button" title="Continuar" onClick={handleContinue} />
          <Button disabled={!visible} tertiary type="button" title="Fechar" onClick={onClose} />
        </>
      }
    />
  );
};
